import request from './request'

export function getRunnerTypeList(params) {
  return request({
    url: '/admin/runner-types',
    method: 'get',
    params
  })
}

export function getRunnerTypeOptions() {
  return request({
    url: '/admin/runner-types/options',
    method: 'get'
  })
}

export function createRunnerType(data) {
  return request({
    url: '/admin/runner-types',
    method: 'post',
    data
  })
}

export function updateRunnerType(id, data) {
  return request({
    url: `/admin/runner-types/${id}`,
    method: 'put',
    data
  })
}

export function deleteRunnerType(id) {
  return request({
    url: `/admin/runner-types/${id}`,
    method: 'delete'
  })
}
